import { useFeatureFlagValue } from '@/hooks/useFeatureFlag';
import { validatePositiveNumber } from '@/utils/numberValidation';

export const useGetSignUpBonusMinimumSpendValue = (): number => {
  const value = useFeatureFlagValue('sign-up-bonus-minimum-spend');
  return validatePositiveNumber(value);
};
